import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations, LANGUAGES } from "./translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "hsc_lang";

function detectInitial() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && translations[saved]) return saved;
    const browser = (navigator.language || "it").slice(0, 2);
    if (translations[browser]) return browser;
  } catch (e) {
    /* ignore */
  }
  return "it";
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(detectInitial);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
      document.documentElement.lang = lang;
    } catch (e) {
      /* ignore */
    }
  }, [lang]);

  const changeLang = useCallback((code) => {
    if (translations[code]) setLang(code);
  }, []);

  const t = translations[lang] || translations.it;

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
